import React from 'react';

function Terms() {
  return (
    <div style={{ padding: '50px' }}>
      <h1>Welcome to Financial Advisory</h1>
      <p>Guiding your business through strategic transformation and financial excellence.</p>
    </div>
  );
}

export default Terms;